__webpack_require__.p = "https://timothyf1.github.io/dragon-treasure/";